import { Button } from "@deepguide-ai/ui/button"
import { Loader2 } from "lucide-react"
import { Lock, Unlock } from "lucide-react"

interface LockCardProps { 
 
    onWithdraw?: () => void
    isWithdrawing?: boolean
}

const LockCard = ({ onWithdraw, isWithdrawing }: LockCardProps) => {
  return (
      <div className='rounded-md border border-amber-200 bg-amber-50 p-4 dark:border-amber-800 dark:bg-amber-900/20'>
          <div className='flex items-start gap-3'>
              <Lock className='h-5 w-5 text-status-orange dark:text-amber-400 mt-0.5' />
              <div className='flex-1'>
                  <h4 className='text-sm font-medium text-status-orange-strong'>
                      Upload locked
                  </h4>
                  <p className='mt-1 text-sm text-amber-700 dark:text-amber-400'>
                      This submission is awaiting review. To upload new files, withdraw the submission and submit a new revision.
                  </p>
                  {onWithdraw && (
                      <Button
                          variant='outline'
                          size='sm'
                          onClick={onWithdraw}
                          disabled={isWithdrawing}
                          className='mt-3 border-amber-300 text-amber-700 hover:bg-amber-100 dark:border-amber-700 dark:text-amber-400 dark:hover:bg-amber-900/40'
                      >
                          {isWithdrawing ? (
                              <Loader2 className="h-3.5 w-3.5 animate-spin" />
                          ) : (
                              <Unlock className="h-3.5 w-3.5" />
                          )}
                          Withdraw Submission
                      </Button>
                  )}
              </div>
          </div>
      </div>
  )
}

export default LockCard
